// SPDX-License-Identifier: GPL-3.0-or-later
// Entry point of the overlay page bundle (public/assets/overlay.js).

import { bootOverlayPage } from "./overlay-page.ts";

bootOverlayPage(document, window);
